// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file device/device_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file device/device_model.proto.
 */
export const file_device_device_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChlkZXZpY2UvZGV2aWNlX21vZGVsLnByb3RvEhRjb20uZ2VtLmJmZi5jb250cmFjdCKUAwoGRGV2aWNlEhAKCGRldmljZUlkGAEgASgJEjsKCHBsYXRmb3JtGAIgASgOMikuY29tLmdlbS5iZmYuY29udHJhY3QuRGV2aWNlLlBsYXRmb3JtVHlwZRIOCgZkZXZpY2UYAyABKAkSDgoGb3NOYW1lGAQgASgJEhEKCW9zVmVyc2lvbhgFIAEoCRISCgphcHBWZXJzaW9uGAYgASgJEjgKBnN0YXR1cxgHIAEoDjIjLmNvbS5nZW0uYmZmLmNvbnRyYWN0LkRldmljZS5TdGF0dXNIAIgBARIQCghzdGF0dXNBdBgIIAEoAyJRCgxQbGF0Zm9ybVR5cGUSBwoDV0VCEAASBwoDSU9TEAESCwoHQU5EUk9JRBACEgoKBkhVQVdFSRADEgsKB0RFU0tUT1AQBBIJCgVPVEhFUhAFIkoKBlN0YXR1cxILCgdQRU5ESU5HEAASCwoHVFJVU1RFRBABEgsKB0JMT0NLRUQQAhIMCghVTkxPQ0tFRBADEgsKB0RFTEVURUQQBEIJCgdfc3RhdHVzQhgKFGNvbS5nZW0uYmZmLmNvbnRyYWN0UAFiBnByb3RvMw'
  );

/**
 * @generated from message com.gem.bff.contract.Device
 */
export type Device = Message<'com.gem.bff.contract.Device'> & {
  /**
   * @generated from field: string deviceId = 1;
   */
  deviceId: string;

  /**
   * @generated from field: com.gem.bff.contract.Device.PlatformType platform = 2;
   */
  platform: Device_PlatformType;

  /**
   * @generated from field: string device = 3;
   */
  device: string;

  /**
   * @generated from field: string osName = 4;
   */
  osName: string;

  /**
   * @generated from field: string osVersion = 5;
   */
  osVersion: string;

  /**
   * @generated from field: string appVersion = 6;
   */
  appVersion: string;

  /**
   * @generated from field: optional com.gem.bff.contract.Device.Status status = 7;
   */
  status?: Device_Status;

  /**
   * @generated from field: int64 statusAt = 8;
   */
  statusAt: bigint;
};

/**
 * Describes the message com.gem.bff.contract.Device.
 * Use `create(DeviceSchema)` to create a new message.
 */
export const DeviceSchema: GenMessage<Device> =
  /*@__PURE__*/
  messageDesc(file_device_device_model, 0);

/**
 * @generated from enum com.gem.bff.contract.Device.PlatformType
 */
export enum Device_PlatformType {
  /**
   * @generated from enum value: WEB = 0;
   */
  WEB = 0,

  /**
   * @generated from enum value: IOS = 1;
   */
  IOS = 1,

  /**
   * @generated from enum value: ANDROID = 2;
   */
  ANDROID = 2,

  /**
   * @generated from enum value: HUAWEI = 3;
   */
  HUAWEI = 3,

  /**
   * @generated from enum value: DESKTOP = 4;
   */
  DESKTOP = 4,

  /**
   * @generated from enum value: OTHER = 5;
   */
  OTHER = 5,
}

/**
 * Describes the enum com.gem.bff.contract.Device.PlatformType.
 */
export const Device_PlatformTypeSchema: GenEnum<Device_PlatformType> =
  /*@__PURE__*/
  enumDesc(file_device_device_model, 0, 0);

/**
 * @generated from enum com.gem.bff.contract.Device.Status
 */
export enum Device_Status {
  /**
   * @generated from enum value: PENDING = 0;
   */
  PENDING = 0,

  /**
   * @generated from enum value: TRUSTED = 1;
   */
  TRUSTED = 1,

  /**
   * @generated from enum value: BLOCKED = 2;
   */
  BLOCKED = 2,

  /**
   * @generated from enum value: UNLOCKED = 3;
   */
  UNLOCKED = 3,

  /**
   * @generated from enum value: DELETED = 4;
   */
  DELETED = 4,
}

/**
 * Describes the enum com.gem.bff.contract.Device.Status.
 */
export const Device_StatusSchema: GenEnum<Device_Status> =
  /*@__PURE__*/
  enumDesc(file_device_device_model, 0, 1);
